import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, User, ArrowRight, Loader2 } from 'lucide-react';
import { blogService } from '../services/blogService';
import DefaultSEO from '../components/DefaultSEO';

const Blogs = () => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const data = await blogService.getBlogs();
                // Laravel pagination returns data in .data.data
                setBlogs(data.data.data || []);
                setLoading(false);
            } catch (err) {
                console.error('Error fetching blogs:', err);
                setError('Failed to load blogs. Please try again later.');
                setLoading(false);
            }
        };

        fetchBlogs();
    }, []);

    if (loading) {
        return (
            <div className="container py-5 d-flex justify-content-center align-items-center min-vh-100">
                <Loader2 className="animate-spin text-primary" size={48} />
            </div>
        );
    }

    if (error) {
        return (
            <div className="container py-5 text-center min-vh-100">
                <h2 className="text-danger mb-3">Oops!</h2>
                <p className="text-muted">{error}</p>
                <button onClick={() => window.location.reload()} className="btn btn-primary mt-3">Retry</button>
            </div>
        );
    }

    return (
        <div className="container py-5 min-vh-100">
            <DefaultSEO title="Travel Blog | ZoyoTrip" description="Read our latest travel guides, tips, and destination insights to plan your next perfect trip." />
            <div className="text-center mb-5">
                <h1 className="fw-bold display-5 mb-3">ZoyoTrip Travel Blog</h1>
                <p className="text-muted fs-5">Stories, guides, and tips to inspire your next adventure.</p>
            </div>

            <div className="row g-4">
                {blogs.length > 0 ? blogs.map((blog) => (
                    <div key={blog.id} className="col-md-6 col-lg-4">
                        <div className="card h-100 border-0 shadow-sm hover-shadow transition">
                            <img
                                src={blog.cover_img ? `${(process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000/api/v1').replace(/\/api\/v1\/?$/, '')}/storage/${blog.cover_img}` : "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='800' height='400' viewBox='0 0 800 400'><rect width='100%' height='100%' fill='%23e5e7eb'/><text x='50%' y='50%' dominant-baseline='middle' text-anchor='middle' font-family='sans-serif' font-size='36' font-weight='bold' fill='%239ca3af'>No Image</text></svg>"}
                                className="card-img-top object-fit-cover"
                                alt={blog.title}
                                style={{ height: '200px' }}
                            />
                            <div className="card-body d-flex flex-column p-4">
                                <div className="mb-2">
                                    <span className="badge bg-primary bg-opacity-10 text-primary rounded-pill px-3 py-2">Travel</span>
                                </div>
                                <h5 className="card-title fw-bold mt-2 lh-base">{blog.title}</h5>
                                <p className="card-text text-muted flex-grow-1">{blog.subcontent}</p>

                                <div className="d-flex align-items-center justify-content-between mt-4">
                                    <div className="d-flex align-items-center text-muted small">
                                        <Calendar size={14} className="me-1" />
                                        <span>{new Date(blog.created_at).toLocaleDateString()}</span>
                                    </div>
                                    <Link to={`/blogs/${blog.slug}`} className="btn btn-link text-primary text-decoration-none p-0 fw-bold d-flex align-items-center">
                                        Read More <ArrowRight size={16} className="ms-1" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                )) : (
                    <div className="col-12 text-center py-5">
                        <p className="text-muted">No blogs found.</p>
                    </div>
                )}
            </div>

            <style jsx>{`
                .hover-shadow:hover { box-shadow: 0 1rem 3rem rgba(0,0,0,.175)!important; transform: translateY(-5px); }
                .transition { transition: all 0.3s ease; }
                .animate-spin { animation: spin 1s linear infinite; }
                @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
            `}</style>
        </div>
    );
};

export default Blogs;